import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Piece, Shipment } from '../interfaces';

export type Los = Piece | Shipment;

@Injectable({
  providedIn: 'root'
})
export class BackendService {
  constructor(private http: HttpClient) { }

  getLos(losId: string): Observable<Los> {
    const losUrl = new URL(losId);
    // rewrite urls to fetch them all from the same host
    const fetchUrl = `${location.origin}${losUrl.pathname}`;
    return this.http.get<Los>(fetchUrl);
  }
}
